import type { StoryTimelineItem } from "@/types/content";

export default function StoryTimeline({ items }: { items: StoryTimelineItem[] }) {
  if (!items.length) return null;

  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-6">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <i className="ri-route-line text-primary-600" aria-hidden="true"></i>
        线索时间线
      </h2>
      <ol className="mt-5 space-y-5">
        {items.map((item) => (
          <li key={`${item.date}-${item.text}`} className="relative flex gap-4 pl-1">
            <span className="flex flex-col items-center">
              <span className="mt-1 flex h-3 w-3 shrink-0 items-center justify-center rounded-full bg-primary-500 ring-4 ring-primary-100"></span>
              <span className="mt-1 w-px flex-1 bg-background-300" aria-hidden="true"></span>
            </span>
            <span className="pb-1">
              <span className="block text-xs font-label font-semibold tracking-wide text-primary-700">
                {item.date}
              </span>
              <span className="mt-1 block text-sm leading-relaxed text-foreground-700">{item.text}</span>
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}